import React from 'react';
import Colors from '../../Styles/Colors';
import _ from 'lodash';

export default class Loader extends React.Component {

    constructor() {
        super();
        this.state = {
            spinnerColor: Colors.pink
        }
    }

    componentWillReceiveProps() {
        let spinnerColor = _.sample(Colors);
        if (spinnerColor === Colors.grey || spinnerColor === Colors.brown || spinnerColor === Colors.black) {
            spinnerColor = Colors.pink;
        }
        this.setState({ spinnerColor });
    }

    render() {
        return (
            <div>
                {
                    this.props.showLoader ? (<div className="backdrop">
                        <div className="loader text-center">
                            <h2>Loading, please wait...</h2>
                            <div className="spinner-border" style={{ color: this.state.spinnerColor }} />
                        </div>
                    </div>) : (<div></div>)
                }
            </div>
        );
    }
}